import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import KhetmaProgress from "../sessions/KhetmaProgress";
import StudentModel from "../../api/models/StudentModel";
import KhetmaPopoverComponent from "../popover-khetma";
import CertificateModal from "../modal/CertificateModal";
import { makeApiRequest, showApiErrorMessages } from "../../helpers";
import { ApiResponse } from "../../api/apiResponse";
import { addCertificateRecommendation } from "../../api/endpoints/supervisors/students";
import CandidateCourseModel from "../../api/models/CandidateCourseModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
type KhetmaCardProps = {
  student: StudentModel;
};

export default function KhetmaCard(props: KhetmaCardProps) {
  const { student } = props;
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });

  const time = !!student.student_statistic
    ? student.student_statistic!.averageSessionDurationInMinutes.toFixed()
    : 0;

  const [open, setOpen] = useState<boolean>(false);

  const addCertificateRecommendationStudent = () => {
    makeApiRequest(
      () => addCertificateRecommendation(student?.id ?? ""),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          setOpen(false);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };

  const learnDash = useMemo(() => {
    if (student.learn_dash_progresses?.length) {
      const ListCourses = CandidateCourseModel.fromApiResponse(
        student.learn_dash_progresses
      );
      let totalStepsCounter = 0;
      let completedCourse = 0;
      ListCourses.forEach((course: CandidateCourseModel) => {
        completedCourse += course?.stepsCompleted ?? 0;
        totalStepsCounter += course?.totalSteps;
      });
      return {
        totalSteps: totalStepsCounter,
        completedCourse: completedCourse,
      };
    }
    return { totalSteps: 0, completedCourse: 0 };
  }, [student]);

  return (
    <>
      <div className="w-full   p-4 bg-white rounded-lg shadow flex-col justify-center  gap-4 inline-flex">
        <div className="w-full  justify-between items-center gap-4 inline-flex">
          <div className="flex gap-2  flex-1 items-start">
            <div className="w-12 h-[52px] relative">
              <UserProfilePictureAvatar
                className="w-10 h-10 left-0 top-0 absolute rounded-full"
                profilePictureUrl={student?.profile_picture_url}
                alt=""
              />
              <UserProfilePictureAvatar
                className="w-8 h-8 left-4 top-5 absolute rounded-full border border-white"
                profilePictureUrl={student?.tutor?.profile_picture_url}
                alt=""
              />
            </div>
            <div className=" h-[52px] flex-col justify-center items-end inline-flex">
              <div className="self-stretch  text-gray-800 text-lg font-semibold leading-[27px]">
                {student?.fullNameWithoutMiddle}
              </div>
              <div className="self-stretch  text-gray-500 text-sm font-normal leading-tight">
                {student?.tutor?.fullNameWithoutMiddle}
              </div>
            </div>
          </div>
          <div className=" relative flex gap-2 items-center ">
            <div className="flex flex-col items-end">
              <h3 className="text-gray-500 text-xs ">{t("sessionTime")}</h3>
              <p className="text-gray-700 text-sm font-medium ">
                {t("time", {
                  count: time as any,
                })}
              </p>
            </div>

            <KhetmaPopoverComponent
              setOpen={() => setOpen(true)}
              id={student?.id}
            />
          </div>
        </div>
        <div className="self-stretch    grid  gap-4 md:gap-6   grid-cols-1 md:grid-cols-3">
          <div className="w-full order-3 md:order-none">
            <KhetmaProgress
              title="selfLearning"
              numberOfLevels={learnDash?.totalSteps ?? 0}
              finishedLevels={learnDash?.completedCourse ?? 0}
              showDot={true}
              progressBarColorClass="bg-[#4F46E5]"
              dotColorClass={
                student?.student_statistic?.learnDashProgressionColorClass
              }
            />
          </div>
          <div className="w-full">
            <KhetmaProgress
              title="sessionProgress"
              numberOfLevels={
                student?.student_statistic?.total_sessions_count ?? 0
              }
              progressBarColorClass="bg-[#10B981]"
              finishedLevels={
                student?.student_statistic?.completed_sessions_count ?? 0
              }
            />
          </div>
          <div className="w-full">
            <KhetmaProgress
              title="readingProgress"
              progressBarColorClass="bg-brandblue-500"
              numberOfLevels={student?.student_statistic?.total_pages ?? 0}
              finishedLevels={student?.student_statistic?.total_read_pages ?? 0}
            />
          </div>
        </div>
      </div>
      <CertificateModal
        addRecommendationCertificate={() =>
          addCertificateRecommendationStudent()
        }
        open={open}
        setOpen={() => setOpen(false)}
      />
    </>
  );
}
